import React, { Component, useState } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  OverlayTrigger,
  Tooltip,
  Table,
  Modal,
  InputGroup,
  
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Select from "react-select";
import axios from 'axios';
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { updateQuote,getallrider,EditSubscriptionOrder,get_single_lead_data,UpdateDeliveryStatus,DownloadDeliveryInvoice,searchMedicationForOrder,getCity,getMedicationcategory,AddMedication,getCountry,getMedication,AddOrder,getcitywiseMedication,get_lead_old_data,getOrderById,getOrdersbyid,getmedicationdatabyid,searchlastsubscription, EditOrder, oDocApiCall, DownloadOrder, SendQuote, getremaincreditforleaduser, searchPackageForOrder, getSubscriptionOrderById, Get_Settings_byid} from "../../../Listfunction";
import DatePicker from "react-datepicker";
import Datetime from "react-datetime";
import "react-datepicker/dist/react-datepicker.css";
import LoadingSpinner from 'views/Components/loadingSpinner';
import SweetAlert from "react-bootstrap-sweetalert";
import Downshift from 'downshift';
import NotificationSystem from 'react-notification-system';
import {style} from "../../../variables/Variables";
import LoadingOrder from 'views/Components/loadingOrder';
import LoadingMedication from 'views/Components/loadingMedication';
import {Collapse} from 'react-collapse';
import { rider } from "../Rider/rider";

class editsubscriptionOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      subscribername :'',
      selectedSubscriberName : '',
      typing: false,
      typingTimeout: 0,
      selectedmedication :'',
      selectedSubscriber : '',
      selectedFile:[],
      processing:true,
      subscriber_detail : [],
      ordernote : null,
      // source : '1',
      // delivery_type : '1',
      country_detail : [],
      newmargin : '',
      avalable_flash_point: '',
      contentLoading : true,
      medication_detail : [],
      addmedicationdetailform : [],
      subscriber : '0',
      subscriberError : null,
      opharmareferance : '',
      mypharmareferance : '',
      mypharmareferanceError : null,
      opharmareferanceError : null,
      prescription : '',
      priscriptionurl : [],
      priscriptionurlError : null,
      orderdate : new Date(),
      paymentduedate : new Date(),
      notedisplay : false,
      ordernotedisplay : false,
      prescription_note : '',
      pdfDownloadUrl: '',
      pdfFile: null,
      prescription_text : '',
      source : '1',
      medicationItems :[],
      srno : '',
      description : '',
      unitprice : '',
      quantity : '',
      subtotal : '',
      
      basketvalue : '',
      deliverytype : '1',
      deliverycharge : '',
      deliverychargeError : null,
      totalcost : '',
      totalcostError : null,
      lastsubscriptionorder : '',
      lastsubscriptionorderError : null,
      loading : false,
      username : '',
      useremail : '',
      userphone : '',
      usermobile : '',
      discountamount: 0,
      
      name : '',
      nameError : null,
      mobileno : '',
      mobilenoError : null,
      status : '1',
      orderStatusLabel: '',
      statusError : null,
      phoneno : '',
      phonenoError : null,
      email : '',
      emailError : null,
      addressline1 : '',
      addressline1Error : null,
      addressline2 : '',
      city : '0',
      cityError : null,
      postalcode : '',
      postalcodeError : null,
      country : '0',
      countryError : null,
      orderdetail : [],
      address_form_data : [],
      order_form_detail : [],
      inputList :  [],
      companyname : '',
      discount : 0,
      companynote : '',
      _notificationSystem: null,
      cardHidden: true,
      leadid : '',
      lastsubscription : [],
      showModal: false,
      subscriptiondetail : [],
      medicationdata : [],
      quanitydata : [],
      addressdata: [],
      noRecordFound : false,
      address_id : '',
      addressaccess : '0',
      addressradio : '',
      medicationdataList : [],
      alert : null,
      medicationaddError : null,
      marginmodal : false,
      discountmodal : false,
      prescriptionmodal:false,
      margintype : '1',
      discountpercentage : 0,
      marginpercentage : 0,
      marginamount : 0,
      b2borganizationdiscount : 0,
      showmediactonModal: false,
      medicationitemcode : '',
      medicationitemcodeError : null,
      medicationdescription : '',
      medicationdescriptionError : null,
      medicationcategory :'0',
      medicationis_featured : "2",
      medicationcategoryError : null,
      medicationunitprice : '',
      medicationunitpriceError : null,
      medicationaddcommision : "1",
      medicationitemname : '',
      medicationitemnameError : null,
      medicationcity : '0',
      medicationcityError : null,
      medicationprice : 0,
      category_detail : [],
      marginfinalamount: 0,
      dynamicfinalpercentage : 0,
      city_info : [],
      b2baccess : 0,
      displaymarginamount : '',
      displaymarginpercentage : '',
      errormessages : [],
      medicationerrormessage : [],
      addnewaddress : false,
      healthcondition : null,
      healthconditionItems : [],
      healthconditiondetails : [],
      paymentoption : null,
      paymentoptionError : null,
      medicationloading : true,
      rider_id : null,
      rider_idError : null,
      rider_details : [],
      rider_data : [],
      channel : '',
      request_quote_notification : null,
      quotenotification : null,
      used_credit_point : null,
      credit_being_use : null,
      alertquote : null,
      order_status : '',
      not_get_medicine:'',
      
      subscription_date: new Date(),
      delivery_date : new Date(),
      expressdeliverychargevalue : '',
      delivery_data : [],
    }
    
    
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handledate = this.handledate.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handlebasketandsubtotal = this.handlebasketandsubtotal.bind(this);
    this.subdetail =  this.subdetail.bind(this);
    this.lastorderdetail = this.lastorderdetail.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.medicationChange = this.medicationChange.bind(this);
    this.medication_item_code_error = React.createRef();
    this.warningChangeAddress = this.warningChangeAddress.bind(this);
    this.warningAddAddress = this.warningAddAddress.bind(this);
    this.message_error = React.createRef();
    this.checkpatient = this.checkpatient.bind(this);
    this.oncheckquote = this.oncheckquote.bind(this);
    this.downloadinvoice = this.downloadinvoice.bind(this);
    this.updateStatus = this.updateStatus.bind(this);
    // this.handledynamic = this.handledynamic.bind(this);
    // this.handleaddinput = this.handleaddinput.bind(this);
  }
  updateStatus(deliver_id)
  {
    
    var token = JSON.parse(localStorage.getItem('user'));  
        const  obj = token.token;
        this.setState({ pdfloading: true,processing:false }, () => {
          UpdateDeliveryStatus(deliver_id,this.props.match.params.id,obj)
        .then((res)=>{
          console.log(res,"delivery status")
         // alert("Delivery status updated")
           getSubscriptionOrderById(this.props.match.params.id,obj)
         .then((res) => {
             const data = res.data;
             const date = new Date(data.subscription_date );
             console.log(data , "orderdata")
             var  delivery_data  = data.deliveryItems;
             this.setState({delivery_data:delivery_data})
         })
          //this.props.history.push("/admin/subscriptionorder/" + this.props.match.params.id);
          //
        })
        })
  }
  checkpatient(e)
  {
    var checked =  e.target.checked
    console.log(checked,'checked')
    
    this.setState({ quotenotification: checked  });
  }
  downloadinvoice(id)
{
        // const FileDownload = require('js-file-download');
        var token = JSON.parse(localStorage.getItem('user'));  
        const  obj = token.token;
        this.setState({ pdfloading: true,processing:false }, () => {
          DownloadDeliveryInvoice(id,this.props.match.params.id,obj)
        .then((res)=>{
        this.setState({ pdfloading: false })
        var ddata = res.data.data.pdf_url
        const link = document.createElement('a')
        link.href = ddata;
        link.target = '_blank';
        link.setAttribute('download','order_'+id+'.pdf')
        // document.body.appendChild(link)
        link.click()
        // this.setState({
        //   viewinvoice : ddata
        // })
        this.setState({ pdfloading: false ,processing:true})
        })
        })
}
  handleDateChange = date => {
      
    this.setState({
      orderdate: date
    });
  };
  handlePaymentDueDate = date => {
    this.setState({ paymentduedate :  date });
  }
  upload(){

    document.getElementById("selectImage").click()
  }

  medicationChange= ((event)=> 
  {
       const target = event.target;
      const value = target.type === 'select' ? target.selected : target.value;
      const name = target.name;    
      this.setState({
        [name]: value
      });
  })
  handleAddClick = () => {
    
    if(this.state.inputList.length === 0)
    {
      this.serial = 1
    }
    this.setState({inputList:[...this.state.inputList, { srno: this.getSerial(), description: "", unitprice: "",newmargin : '',discount:"",deliverycharges:'', quantity: 1, subtotal: "" }]})
  };
  handledate =((event) => {
  });
  
  addanother()
  {
    this.setState({inputList :  []}) //empty exitsing medictaion list
    this.serial = 1
    this.setState({
      addressaccess : '1',
      addressline2: '',
      addressline1 : '',
      alert: null,
      city : '0',
      postalcode : '',
      country : '0',
      medicationItems : [],
      medication_detail : [],
      cityError : null,
      countryError : null,
      addnewaddress : true,

    })
    this.setState({
      address_id : '0',
      addressline2: this.state.addressline2,
      addressline1 : this.state.addressline1,
      city : this.state.city,
      postalcode : this.state.postalcode,
      country : this.state.country
    })
    this.handlebasketandsubtotal()
  }

  handleSuccess(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'success';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>Subscription Order</b> - Updated Successfully .
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
  }
  handleClick(position){
    var color = Math.floor((Math.random() * 4) + 1);
    var level;
    switch (color) {
        case 1:
        level = 'success';
        break;
        case 2:
        level = 'warning';
        break;
        case 3:
        level = 'error';
        break;
        case 4:
        level = 'info';
        break;
        default:
        break;
    }
    level = 'error';
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-gift"></span>),
        message: (
            <div>
                 <b>something went wrong</b>.
            </div>
        ),
        level: level,
        position: position,
        autoDismiss: 15,
    });
  


}
async componentDidMount(){
   
  var token = JSON.parse(localStorage.getItem('user'));  
  const  obj = token.token;
 // console.log(token);
 this.setState({_notificationSystem: this.refs.notificationSystem})
 setTimeout(
   function() {
     this.setState({ cardHidden: false }); 
   }.bind(this),
   700
 );

  // try{
  //   let res = DownloadOrder(this.props.match.params.id,obj)
  //   res.then(res => {
  //     this.setState({pdfDownloadUrl: res.data.data.pdf_url});
  //   })
  //   }catch(err){
  //     console.log("Err",err);
  //   };
  
 

 var country_id = 1

  getCity(obj,country_id)
  .then(res => {
    // console.log(res,'city');
    this.setState({ city_info :  res.data });
  })

  var settings_id = "2";
    Get_Settings_byid(settings_id,obj)
    .then(res=>{
      console.log(res.data.data.setting_value,'settings')
      this.setState({expressdeliverychargevalue :res.data.data.setting_value  });
    })

 await getCountry(obj)
  .then(cdata => {
    const countrydata =  cdata.data;
    this.setState ({
      country_detail : countrydata 
    })
  })
  
  let medicomplete = 1
  let p_no = 1
  while(medicomplete == 1)
  {
    await getMedicationcategory(obj,p_no,500)
    .then(cat_res => {
      var cat = cat_res.data;
      if(cat.data.length == 0)
      {
           medicomplete = 0
      }
      else
      {
//                compelte = 0
       var array1 = this.state.category_detail;
       var array2 = array1.concat( cat.data)
        
         this.setState({
           category_detail : array2
         })
        }
    })
    p_no++;
  }
  let role = 5;
  getallrider(role,obj)
  .then((res) => {
    
    const data = res.data;
    
     var array1 = this.state.rider_details;
     var array2 = array1.concat( data)
    
      this.setState({
        rider_details : array2,
      })
      
      let riderItems = []
                this.state.rider_details.map((x, i) => {
                  riderItems.push({ value:x.id , label:  x.name })
                })
                this.setState({
                  rider_data : riderItems
                })
  })
 
  
var s_lead_id = 0
var  address_data  =""
var  delivery_data  =""
  await  getSubscriptionOrderById(this.props.match.params.id,obj)
.then((res) => {
    const data = res.data;
    const date = new Date(data.subscription_date );
    console.log(data , "orderdata")
    address_data = data.address;
    delivery_data  = data.deliveryItems;
    console.log(delivery_data , "order data")
    const lead = data.lead;

        var delitype = ''
    if(data.delivery_type == 1)
    {
      delitype = "1"
    }
    else if(data.delivery_type == 2)
    {
      delitype = "2"
    }
    
    // console.log(data.margin)
    var basketfinalvalue = 0;
    
      basketfinalvalue = parseFloat(data.basket_value) 
    
  
  var pdata = []
  pdata.push({value : data.paymentoption ,label : data.paymentoption});
  let rdata = []
  let ride_data = "";
  if(data.rider_id != null )
  {
  //  console.log(data.rider_id)
   this.state.rider_details.map((r)=>{
        if(r.id == data.rider_id)
        {
          ride_data ={value : r.id,label : r.name}
        }
      }) 
      // console.log(ridedata,'ride data')
      rdata = ride_data;     
  }
  else if(data.rider_id == null && data.channel == "app")
  {
    // this.setState({ rider_id: null  });
    rdata = null;
  }
  else
  {
    rdata.push({value : null,label : null})
  }
  // console.log(rdata,'rdata')
  this.setState({ paymentoption: pdata, rider_id : rdata  });
  // console.log(this.state.rider_id)
  

  s_lead_id =  data.lead_id
    var deli_date = new Date(data.delivery_date)
    this.setState({
      subscriber : data.lead_id,
      subscription_date : date,
      basketvalue : data.basket_value,      
      ordernote : data.order_note,
      delivery_date : deli_date,
      deliverycharge : data.delivery_charge,
      deliverytype : delitype,
      totalcost : data.total_cost,
      delivery_data : delivery_data,
      address_id : address_data.id,
       name : address_data.name,
       status : data.order_status,
       orderStatusLabel: data.order_status_label,
       email : address_data.email,
       mobileno : address_data.mobile,
       phoneno :address_data.phone,
       leadid : data.lead_id,
       channel : data.channel,
       
       
      })
      // console.log(this.state.paymentoption,'paymentoption')
      this.subdetail()
      // this.lastorderdata(data.lead_id)
      const inputList1 = []
      var medication_detail = []
      var medicationItems= []
      var ne_med = []
      
     

    
      // console.log(this.state.priscriptionurl,'pu')
      data.orderItems.map((x,indx) => {
         medication_detail[indx] = x;
         medicationItems.push({ value:x.package_id , label: x.package_title})
         ne_med[indx] =medicationItems
      })
      
    this.setState({  
      medication_detail : medication_detail,
      medicationItems : medicationItems  
    })
    // set default values
      data.orderItems.map((x,indx) => {
        var serchargeValue = 0;
        var discountValue = 0;
        if(x.charge_value != null)
        {
          serchargeValue = x.charge_value
        }
        if(x.discount != null)
        {
          discountValue = x.discount
        }
          inputList1.push( { srno:this.getSerial(), description: x.package_id,medi_title:x.package_title, unitprice: x.unit_price, quantity: x.quantity,discount:discountValue,deliverycharges:serchargeValue, subtotal:x.subtotal ,medicationItems:[] ,selectmedication:{ value:x.package_id , label: x.package_title  }})
          })
      this.addrssselect(address_data.id,address_data.city)

    
      this.serial = inputList1.length + 1;
      this.setState({inputList:inputList1})
      
})
getremaincreditforleaduser(this.state.subscriber,obj)
      .then(res=>{
        // console.log(res.data.data.remainingCredit,'remian credit ');
        this.setState({ avalable_flash_point : res.data.remainingCredit  });
      })
await get_single_lead_data(s_lead_id,obj)
.then((res) => {
  
  const data = res.data.data;
  
    this.setState({
      subscriber_detail : data,
    })
   })
   this.handleb2bdetails()
   
  
   
 this.handlebasketandsubtotal()
//
this.setState({contentLoading:false});
  

}
async oncheckquote()
{
  var token = JSON.parse(localStorage.getItem('user'));  
  const  obj = token.token;
  let orderItemsform = []
  this.setState({ alertquote:null });
  this.state.inputList.map((x, i) => {
    orderItemsform.push({ id:x.description, quantity: x.quantity,margin_discount_percentage : x.newmargin })
  })

  
  const channel = this.state.channel;
  const created_by = token.id;
  const date = new Date(this.state.orderdate);
  var dd = ("0" + (date.getDate())).slice(-2);
  var mm = ("0" + (date.getMonth() + 1)).slice(-2);
  var yyyy = date.getFullYear();
  var today = yyyy+"-"+ mm+'-'+dd;

  

  var priscription_data  = ""
  var prescription_text  = "";
  // console.log(this.state.selectedFile,'selected file ');
 if(this.state.selectedFile.length != 0)
 {
  this.setState({processing:true})

  const fdata = new FormData() 
  
  this.state.selectedFile.map((file)=>{
    for(var i=0;i<file.length;i++)
    {
      fdata.append('presription_file[]', file[i])
      console.log(file[i],'in file')
    }
  })
  
 let url = process.env.REACT_APP_NOT_SECRET_CODE+"/orders/prescription";
  await axios.post(url, fdata, {headers : {'Authorization' : 'Bearer '+obj,
  'X-Country-Code' : 'BD',
  'X-Client-Name' : 'WEBSITE',
  'X-Client-Version' : '123',
  'Content-Type':'application/json',
  'X-Request-Id' : '124',
}
  })
  .then(res => { 
      priscription_data  = res.data.data.prescription_url
  })
 }
 else
 {
  let pdata = []
  let ptext = ""
  this.state.priscriptionurl.map(p=>{
    console.log(p,'prescription url');
    if(p.prescription_url.prescription_file.length != 0)
    {
    pdata.push(p.prescription_url.prescription_file)
    }

  })

  prescription_text = this.state.prescription_text
  priscription_data = pdata 
  console.log(prescription_text);
 }
 
    var marginvalue = ""
    if(this.state.margintype == 1)
    {
      if(this.state.marginfinalamount != null)
      {
        marginvalue = parseFloat( this.state.marginfinalamount )
      }
      else
      {
        marginvalue = 0;
      }
    }
    else if(this.state.margintype == 2)
    {
      if(this.state.marginfinalamount != null)
      {
        marginvalue = parseFloat( this.state.marginfinalamount)
      }
      else
      {
        marginvalue = 0;
      }
    }
    var discountper = 0
    if(this.state.dynamicfinalpercentage != 0)
      {
        discountper = parseFloat(this.state.dynamicfinalpercentage)
      }
      else
      {
      discountper = parseFloat(this.state.discount)

      }
    // }
    // else
    // {
    //   discountper = 0
    // }
  // console.log(this.state.status)

  var tag = [];
  if(this.state.healthcondition == null)
  {
    tag = ""
  }
  else
  {
  this.state.healthcondition.map(data => {
    var array1 = tag; 
    var array2 =  array1.concat(data.label);
    tag = array2
  })
}
// console.log(this.state.paymentoption.value,'paymentoption',this.state.subscriber)
  
    
  let paymentop = ""
  if(this.state.paymentoption.value != null)
  {
    // console.log(this.state.paymentoption.value,this.state.paymentoption);
    paymentop = this.state.paymentoption.value;
}
else
{
  this.state.paymentoption.map(po=>{
    paymentop = po.value
  })
}

  this.setState({ processing:false }, () => {
    updateQuote(this.state.subscriber,this.state.source,this.state.opharmareferance,today,this.state.prescription,this.state.priscriptionurl,this.state.deliverytype,this.state.deliverycharge,this.state.lastsubscriptionorder,this.state.address_id,this.state.addressline1,this.state.addressline2,this.state.city,this.state.postalcode,this.state.country,channel,orderItemsform,obj,this.state.basketvalue,this.state.totalcost,this.state.lastsubscriptionorder,this.state.email,this.state.name,this.state.mobileno,this.state.phoneno,this.state.status,priscription_data,this.state.margintype,marginvalue,discountper,tag,paymentop,prescription_text,this.state.not_get_medicine,this.props.match.params.id)
  .then((res)=>{
    
    if(res.data.success === false)
    {
      this.setState({processing:true})
      if(res.data.data.length != 0)
        {
          var ermessage = [];
          for (var key of Object.keys(res.data.data)) {
              var data = res.data.data[key]
              ermessage.push(data)
          }
          this.setState({ errormessages:  ermessage });
          
        }
        else
        {
          this.handleClick('bl')
        }
    }
    else if(res.data.success === true)
    {
      this.setState({processing:true})
      this.handleSuccess('bl')
      setTimeout(() => {
        this.props.history.push('/admin/order_list');
      }, 3000);
    }
    // this.props.history.push('/admin/order_list');
  })
  .catch((error) => {
    
    this.handleNetworkError('bl')
 });
})

}
async onSendQuote()
{
  this.setState({errormessages : []  });
  let error = false ;


    if(this.state.subscriber == "0")
    {error = true
       this.setState({
        subscriberError: (
            <small className="text-danger">
              Subscriber is required.
            </small>
          )
        })
      }else{ this.setState({ subscriberError: null });}
      
       
        if(this.state.paymentoption == null)
      {error = true
         this.setState({
          paymentoptionError: (
              <small className="text-danger">
                Payment Option is required.
              </small>
            )
          })
        }else{ this.setState({ paymentoptionError: null });}
        
        if(this.state.inputList.length == 0  )
        {
          error = true
   
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              ><h4>Please Enter Proper Medication data!</h4></SweetAlert>
            )
          });
         }else 
        {
          error = false
    this.state.inputList.map((x, i) => {
      // console.log(i,x.description,'check i x ')
      if(x.description == "")
        {
          error = true
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              ><h4>Please Enter Proper Medication data!</h4></SweetAlert>
            )
          });
         }else{  
           if(error == true)
           {
            this.setState({ medicationaddError: null });
           }
           else{

           }
          
        }
      
        })
        }
        if(this.state.addnewaddress == true)
        {
          if(this.state.country == "0")
          {error = true
             this.setState({
              countryError: (
                  <small className="text-danger">
                    Country is required.
                  </small>
                )
              })
            }else{ this.setState({ countryError: null });}

          if(this.state.city == "0")
          {error = true
             this.setState({
              cityError: (
                  <small className="text-danger">
                    city is required.
                  </small>
                )
              })
            }else{ this.setState({ cityError: null });}
         

        }
        if(error)
      {
        this.message_error.current.focus();

      }

  if(!error)
  //if(1)
  {
    if(this.state.quotenotification == false)
    {
    this.setState({
      alertquote: (
        <SweetAlert
          className="order_alert"
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.oncheckquote()}
          onCancel={() => this.hideAlertquote()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes!"
          cancelBtnText="Cancel"
          showCancel
        ><h4>This is a quote less order, are you sure you want to send quote ?</h4></SweetAlert>
      )
    });
  }else if(this.state.quotenotification == true){
    var token = JSON.parse(localStorage.getItem('user'));  
    const  obj = token.token;
    let orderItemsform = []
    this.setState({ alertquote:null });
    this.state.inputList.map((x, i) => {
      orderItemsform.push({ id:x.description, quantity: x.quantity,margin_discount_percentage : x.newmargin })
    })
  
    
    const channel = this.state.channel;
    const created_by = token.id;
    const date = new Date(this.state.orderdate);
    var dd = ("0" + (date.getDate())).slice(-2);
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    var today = yyyy+"-"+ mm+'-'+dd;
  
    
  
    var priscription_data  = ""
    var prescription_text  = "";
    // console.log(this.state.selectedFile,'selected file ');
   if(this.state.selectedFile.length != 0)
   {
    this.setState({processing:true})
  
    const fdata = new FormData() 
    
    this.state.selectedFile.map((file)=>{
      for(var i=0;i<file.length;i++)
      {
        fdata.append('presription_file[]', file[i])
        console.log(file[i],'in file')
      }
    })
    
   let url = process.env.REACT_APP_NOT_SECRET_CODE+"/orders/prescription";
    await axios.post(url, fdata, {headers : {'Authorization' : 'Bearer '+obj,
    'X-Country-Code' : 'BD',
    'X-Client-Name' : 'WEBSITE',
    'X-Client-Version' : '123',
    'Content-Type':'application/json',
    'X-Request-Id' : '124',
  }
    })
    .then(res => { 
        priscription_data  = res.data.data.prescription_url
    })
   }
   else
   {
    let pdata = []
    let ptext = ""
    this.state.priscriptionurl.map(p=>{
      console.log(p,'prescription url');
      if(p.prescription_url.prescription_file.length != 0)
      {
      pdata.push(p.prescription_url.prescription_file)
      }
  
    })
  
    prescription_text = this.state.prescription_text
    priscription_data = pdata 
    console.log(prescription_text);
   }
   
      var marginvalue = ""
      if(this.state.margintype == 1)
      {
        if(this.state.marginfinalamount != null)
        {
          marginvalue = parseFloat( this.state.marginfinalamount )
        }
        else
        {
          marginvalue = 0;
        }
      }
      else if(this.state.margintype == 2)
      {
        if(this.state.marginfinalamount != null)
        {
          marginvalue = parseFloat( this.state.marginfinalamount)
        }
        else
        {
          marginvalue = 0;
        }
      }
      var discountper = 0
      if(this.state.dynamicfinalpercentage != 0)
        {
          discountper = parseFloat(this.state.dynamicfinalpercentage)
        }
        else
        {
        discountper = parseFloat(this.state.discount)
  
        }
      // }
      // else
      // {
      //   discountper = 0
      // }
    // console.log(this.state.status)
  
    var tag = [];
    if(this.state.healthcondition == null)
    {
      tag = ""
    }
    else
    {
    this.state.healthcondition.map(data => {
      var array1 = tag; 
      var array2 =  array1.concat(data.label);
      tag = array2
    })
  }
  // console.log(this.state.paymentoption.value,'paymentoption',this.state.subscriber)
    
      
    let paymentop = ""
    if(this.state.paymentoption.value != null)
    {
      // console.log(this.state.paymentoption.value,this.state.paymentoption);
      paymentop = this.state.paymentoption.value;
  }
  else
  {
    this.state.paymentoption.map(po=>{
      paymentop = po.value
    })
  }
  
    this.setState({ processing:false }, () => {
      updateQuote(this.state.subscriber,this.state.source,this.state.opharmareferance,today,this.state.prescription,this.state.priscriptionurl,this.state.deliverytype,this.state.deliverycharge,this.state.lastsubscriptionorder,this.state.address_id,this.state.addressline1,this.state.addressline2,this.state.city,this.state.postalcode,this.state.country,channel,orderItemsform,obj,this.state.basketvalue,this.state.totalcost,this.state.lastsubscriptionorder,this.state.email,this.state.name,this.state.mobileno,this.state.phoneno,this.state.status,priscription_data,this.state.margintype,marginvalue,discountper,tag,paymentop,prescription_text,this.state.not_get_medicine,this.props.match.params.id)
    .then((res)=>{
      
      if(res.data.success === false)
      {
        this.setState({processing:true})
        if(res.data.data.length != 0)
          {
            var ermessage = [];
            for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key]
                ermessage.push(data)
            }
            this.setState({ errormessages:  ermessage });
            
          }
          else
          {
            this.handleClick('bl')
          }
      }
      else if(res.data.success === true)
      {
        this.setState({processing:true})
        this.handleSuccess('bl')
        setTimeout(() => {
          this.props.history.push('/admin/order_list');
        }, 3000);
      }
      // this.props.history.push('/admin/order_list');
    })
    .catch((error) => {
      
      this.handleNetworkError('bl')
   });
  })
  
  }
  }
}
openprescriptionmodal(urls)
{
 
  this.setState({ prescriptionmodal: true  });
}
closeprescriptionmodal()
{
  this.setState({ prescriptionmodal: false  });
}

openmarginmodal()
{
  
  this.setState({ marginmodal : true  });

}
opendiscountmodal()
{
  this.setState({ discountmodal: true  });
}
closedynamicdiscount()
{
 
  var dd= ""
  if(this.state.discountpercentage == 0 || this.state.discountpercentage == null)
  {
    this.setState({ discountpercentage: 0  });
  }
  else
  {
    this.setState({ discountpercentage: this.state.discountpercentage  });
  }
  this.setState({ discountmodal: false,
    // dynamicfinalpercentage : 0
  });

}
closedynamicmargin()
{
  var margin = "";
  if(this.state.margintype == 1)
  {
    if(this.state.marginpercentage == null || this.state.marginpercentage == 0)
    {
      this.setState({ marginpercentage : 0 });
    }
    else
    {
      this.setState({marginpercentage : this.state.marginpercentage})
    }
  }
  else if(this.state.margintype == 2)
  {
    if(this.state.marginamount == null || this.state.marginamount == 0)
    {
      this.setState({ marginamount : 0 });
    }
    else
    {
      this.setState({ marginamount: this.state.marginamount  });
    }
  }
  
  this.setState({ marginmodal : false ,
    // marginfinalamount : margin
  });

}
pdfGenerateCall = async () => {
  // var token = JSON.parse(localStorage.getItem('user'));  
  // const  obj = token.token;
  // try{
  //   let res =await DownloadOrder(this.props.match.params.id,obj)
  //     this.setState({pdfDownloadUrl: res.data.data.pdf_url});
  //     return res.data.success
  //   }
  //   catch(err){
  //     console.log(err)
  //   }
    }
odocFunction = () => {
  // if(this.state.opharmareferance){

  //   const odocOrdersList ={1:"submitted",2:"processing",3:"dispatched",4:"delivered",5:"cancelled",6:"attempted",7:"unreachable",8:"created",9:'new'}

  //   const odocAdressObjRaw = this.state.addressdata.find(val => val.id=this.state.address_id);
  //   let odocAdressObj;
  //   if(odocAdressObjRaw){
  //   odocAdressObj = {
  //     address_line1: odocAdressObjRaw.address_line1,
  //     address_line2: odocAdressObjRaw.address_line2,
  //     city: this.state.city_info.find(val => val.id == odocAdressObjRaw.city).city_name,
  //     country: this.state.country_detail.find(val=>val.id == odocAdressObjRaw.country_id).country_name
  //   }
  // }else{
  //   odocAdressObj = {
  //     address_line1: this.state.addressline1,
  //     address_line2: this.state.addressline2,
  //     city: this.state.city_info.find(val => val.id == this.state.city).city_name,
  //     country: this.state.country_detail.find(val=>val.id == this.state.country).country_name
  //   }
  // }

  //   const odocAdress = Object.values(odocAdressObj).join();
  //   const odocNote = this.state.ordernote;
  //   const opharmareferanceRaw = this.state.opharmareferance.split('-')
  //   const odocID = opharmareferanceRaw[opharmareferanceRaw.length - 1];
  //   const odocDeliveryType = (this.state.deliverytype==1)?"standard":"express";

  //   fetch(this.state.pdfDownloadUrl)
  //   .then(async (response) => {
  //     const newBlob = await response.blob();
  //     const blob = new Blob([newBlob], {type:'application/pdf'})
  //     this.setState({pdfFile: blob})

  //     const formData = new FormData() 
  //     formData.append('file',this.state.pdfFile)
  //     formData.append('data[address]',odocAdress)
  //     formData.append('data[deliveryMethod]',odocDeliveryType)
  //     formData.append('data[partnerStatus]',odocOrdersList[this.state.status])
  //     formData.append('data[notes]',odocNote)
  //     formData.append('data[price]',this.state.totalcost)
      
  //     await oDocApiCall(odocID,formData);
  //   }).catch(err=>console.log(err))
  // }
}

submitdynamicdiscount()
  {
    this.handlebasketandsubtotal()
    var dd = ""
    if(this.state.discountpercentage != null || this.state.discountpercentage != 0)
    {
      dd= this.state.discountpercentage;
    }
    else
    {
      dd= 0
    }
    this.setState({
      discountmodal:false,
      dynamicfinalpercentage : dd
    })
  }
  submitdynamicmargin()
  {
    this.handlebasketandsubtotal()
    
    var margin = "";
    if(this.state.margintype == 1)
    {
      if(this.state.marginpercentage != null || this.state.marginpercentage != 0)
      {
        margin = this.state.marginpercentage
      }
      else
      {
        margin = 0
      }
      this.setState({ displaymarginpercentage : margin  });

    }
    else if(this.state.margintype == 2)
    {
      if(this.state.marginamount != null || this.state.marginamount != 0)
      {
      margin = this.state.marginamount
      }
      else
      {
        margin = 0;
      }
      this.setState({ displaymarginamount : margin  });

    }

    this.setState({
      marginmodal:false,
      marginfinalamount : margin
    })
  }
handlebasketandsubtotal()
{
  // console.log('hi')
    
  var data = 0
  var data2 = 0
  var final = 0
  var basketamount  = 0
  var discount_amount =0;
  var withoutdiscount = 0
  this.setState({ loading: true }, () => {
    /*
  this.state.inputList.map((bas)=>{
  
    var basket_value = parseFloat(bas.subtotal) 
    var total_cost = 0
    //convenience charges
    if(bas.quantity == 1){
      var total_delivery_charge = 1 * bas.deliverycharges;
       total_cost =  parseFloat(basket_value) +  parseFloat(total_delivery_charge);
    }else{
      var other_item_delivery_charge =  parseFloat(bas.deliverycharges) /2;
      var total_delivery_charge =  parseFloat(bas.deliverycharges) +  parseFloat(( parseFloat((bas.quantity -1)) *  parseFloat(other_item_delivery_charge)));
      
       total_cost =  parseFloat(basket_value) +  parseFloat(total_delivery_charge);
     
    }

    // total basket amount
    data =parseFloat( data) + parseFloat(total_cost) 
    data2  =parseFloat( data2) + parseFloat(bas.subtotal) 
  }) */
  this.state.inputList.map((bas)=>{
   /* if(bas.discount != 0)
    {
     discount_amount = ( parseFloat(bas.subtotal) * parseFloat(bas.discount)) / 100;
    } */
    data =parseFloat( data) + parseFloat(bas.subtotal) + parseFloat(bas.deliverycharges) 
    // discount amount
    
   });

   
  
  var amount = parseFloat( data) 
  
  basketamount = parseFloat( data) 
 
  var totalvalue = "";
  var amount = parseFloat( data) 
  
    totalvalue = parseFloat(amount).toFixed(2);
  
  
  data = data.toFixed(2)
  
  
  this.setState({
    loading : false,
    basketvalue : amount,
    totalcost : totalvalue,
    discountamount : discount_amount,
  })
})
  
}

  onChange = ((event) => {
    const target = event.target;
    const value = target.type === 'select' ? target.selected : target.value;
    // const value = target.type === 'datetime' ? target.Datetime : target.value;

    const name = target.name;

    this.setState({
      [name]: value
    });
    if(name == "margintype")
  {
    this.setState({ marginfinalamount: 0  });
  }
    this.handlebasketandsubtotal();
    if(name=="country")
    {
      if(value != 0)
      {

      var token = JSON.parse(localStorage.getItem('user'));  
      const  obj = token.token
      var country_id = value

      getCity(obj,country_id)
      .then(res => {
        // console.log(res,'city');
        this.setState({ city_info :  res.data });
      })
  
    }
    else if(value == "0")
    {
      
  this.setState({ city_info :  [] });
      
    }
  } 
  if(name=="deliverytype")
  {
    if(value == "2")
    {
      this.setState({ deliverycharge:  this.state.expressdeliverychargevalue });
    }else
    {
      this.setState({ deliverycharge : 0  });
    }
  }
  if(name == "source")
  {
    if(value == "2")
    {
      this.setState({ mypharmareferance: ""  });
    }
    else if(value =="3")
    {
      this.setState({ opharmareferance : ""  });
    }
  }
  if(name =="city")
  {
    if(value != "0")
    {
      // console.log(value,'city')
      this.addrssselect(0,value)
    }
  }
    if(name == "subscriber")
    {
      this.handlebasketandsubtotal();
      this.handleb2bdetails();
      this.setState({
        lastsubscription : [],
        name : '',
        email : '',
        phoneno : '',
        mobileno : '',
        addressline1 :'',
        addressline2 : '',
        city : '0',
        country : '0',
        // deliverycharge : 0,
        
        postalcode : '',
    // lastsubscription : []
      })
    }
  });
  lastorderdetail(id)
  {
    this.setState({ showModal: true,quanitydata: [],medicationdata : [],medicationdataList : [] })
    var token = JSON.parse(localStorage.getItem('user'));  
    const  obj = token.token;
    
    getOrdersbyid(id,obj)
    .then((res)=>{
      var data = res.data.orderItems;

      
      // var array1 = this.state.quanitydata;
      // var array2 = array1.concat( data)
      let medi_array = []
      const newdata = data.map((mydata)=> (
        getmedicationdatabyid(mydata.medication_id,obj)
        .then((mdata) => {
           medi_array.push({ medicine:mdata.data, quantity: mydata.quantity })
           this.setState({
            medicationdataList :  medi_array
          })
      })
      ))

      this.setState({
        subscriptiondetail : res.data,
        quanitydata :  data
      })

      
    })

    
  }
 
  
  async lastorderdata(id)
  {
    var token = JSON.parse(localStorage.getItem('user'));  
    const  obj = token.token;
    let compelte =1   
    let pg_no = 1
   while(compelte==1)
   {
    this.setState({ noRecordFound : false});  
   await searchlastsubscription(id,pg_no,obj)
    .then((res)=> {
      var orderdata = res.data;
      // console.log(res ,'user old data ')

      if(orderdata.data.length == 0)
      {
        this.setState({ noRecordFound : true});  
      }
        
      if(orderdata.data.length == 0)
      {
           compelte = 0
      }
      else
      {
        compelte = 0
       var array1 = this.state.lastsubscription;
       var array2 = array1.concat( orderdata.data)
        
      this.setState({
        lastsubscription : array2
      })
    }
  })
  pg_no++
  }
}
  handleb2bdetails()
  {
    var token = JSON.parse(localStorage.getItem('user'));  
    const  obj = token.token;
    // console.log(this.state.medicationItems,"---handleB2bdetail medictaion item")
    this.setState({ loading: true }, () => {
      this.state.subscriber_detail.map((detail)=>{
        // console.log(this.state.subscriber,"=", detail.id)
        if(this.state.subscriber == detail.id)
        {
         
          if(detail.b2b == null)
          {
            this.setState({
              loading : false,
              companyname : '',
              // deliverycharge : 0,
              companynote : '',
              discount : 0,
              b2baccess : 0,

            // discountpercentage : 0,
              
                loading : false,
                name : detail.name,
                email : detail.email,
                phoneno : detail.phone,
                mobileno : detail.mobile_no,
                // earn_points : detail.earn_points,
                addressdata : detail.address,
                username : detail.name,
                useremail : detail.email,
                userphone : detail.phone,
                usermobile : detail.mobile_no,
            })
            // console.log(detail.address,"add 1")
            this.lastorderdata(detail.id) 
          }
          else{
            var discount = ""
            if(detail.b2b['discount'] == null)
            {
              discount = 0
            }
            else
            {
              discount = detail.b2b['discount']
            }
          this.setState({
            loading : false,
            b2baccess : 1,
            companyname : detail.b2b['company_name'],
            // deliverycharge : detail.delivery_charge,
            b2bdeliverycharge : detail.b2b['delivery_value'],
            companynote : detail.b2b['note'],
            discount : discount,
            addressdata : detail.address,
            addressline1 : detail.address['address_line1'],
            addressline2 : detail.address['address_line2'],
            city : detail.address['city'],
            country : detail.address['country_id'],
            postalcode : detail.address['postal_code'],
            companyname : detail.b2b['company_name'],
            companynote : detail.b2b['note'],
            username : detail.name,
            useremail : detail.email,
            userphone : detail.phone,
            usermobile : detail.mobile_no,
            // earn_points : detail.earn_points,

            // discountpercentage : 0,

          })
          // console.log(detail.address,"add 2")
          this.lastorderdata(detail.id)
          // console.log(detail.b2b['discount'],'b2bdiscount')

        }
        }
      })
    })
  }
  subdetail()
  {
    var token = JSON.parse(localStorage.getItem('user'));  
    const  obj = token.token;
    // console.log(this.state.leadid,'company');

  get_lead_old_data(this.state.leadid,obj)
        .then((res) => {
          const data = res.data;
          if(data.b2b == null)
          {
            this.setState({
              companyname : '',
              // deliverycharge : '',
              companynote : '',
              discount : 0,
            })

          }else{
          this.setState({
            companyname : data.b2b['company_name'],
            // discount : data.b2b['discount'],
            companynote : data.b2b['note'],
             
          })
        }
        })
      }
      
  

  async onSubmit()
  {
    this.setState({errormessages : []  });
    let error = false ;
    

    if(this.state.subscriber == "0")
    {error = true
       this.setState({
        subscriberError: (
            <small className="text-danger">
              Subscriber is required.
            </small>
          )
        })
      }else{ this.setState({ subscriberError: null });}
      

      
        if(this.state.paymentoption == null)
        {error = true
           this.setState({
            paymentoptionError: (
                <small className="text-danger">
                  Payment Option is required.
                </small>
              )
            })
          }else{ this.setState({ paymentoptionError: null });}
        if(this.state.inputList.length == 0  )
        {
          error = true
   
          this.setState({
            alert: (
              <SweetAlert
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            ><h4>Please Enter Proper Package data!</h4></SweetAlert>
            )
          });
         }else 
        {
          error = false
    this.state.inputList.map((x, i) => {
      // console.log(i,x.description,'check i x ')
      if(x.description == "")
        {
          error = true
          this.setState({
            alert: (
              <SweetAlert
              className="order_alert"
              style={{ display: "block", marginTop: "-100px" }}
              
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            ><h4>Please Enter Proper Package data!</h4></SweetAlert>
            )
          });
         }else{  
           if(error == true)
           {
            this.setState({ medicationaddError: null });
           }
           else{

           }
          
        }
      
        })
        }
        if(this.state.addnewaddress == true)
          {
            if(this.state.country == "0")
            {error = true
               this.setState({
                countryError: (
                    <small className="text-danger">
                      Country is required.
                    </small>
                  )
                })
              }else{ this.setState({ countryError: null });}

              // console.log(this.state.city,'city',this.state.country);
            if(this.state.city == "0")
            {error = true
               this.setState({
                cityError: (
                    <small className="text-danger">
                      city is required.
                    </small>
                  )
                })
              }else{ this.setState({ cityError: null });}
           

          }
         

                  if(this.state.paymentoption == null)
                    {error = true
                      this.setState({
                        paymentoptionError: (
                            <small className="text-danger">
                              Payment Option is required.
                            </small>
                          )
                        })
                      }else{ this.setState({ paymentoptionError: null });}
                      

                      
                       
                      if(error)
                      {
                          this.message_error.current.focus();
                      }
                    if(!error)
                    {
    var token = JSON.parse(localStorage.getItem('user'));  
    const  obj = token.token;
    let orderItemsform = []
    this.state.inputList.map((x, i) => {
      orderItemsform.push({ id:x.description, quantity: x.quantity})
    })
    // console.log(orderItemsform);
    const channel = this.state.channel;
    const created_by = token.id;
    const date = new Date(this.state.subscription_date);
    var dd = ("0" + (date.getDate())).slice(-2);
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    var today = yyyy+"-"+ mm+'-'+dd;

    const deliverydate = new Date(this.state.delivery_date);
    var ddd = ("0" + (deliverydate.getDate())).slice(-2);
    var dmm = ("0" + (deliverydate.getMonth() + 1)).slice(-2);
    var dyyyy = deliverydate.getFullYear();
    var dtoday = dyyyy+"-"+ dmm+'-'+ddd;

  var paymentop = "";
  if(this.state.paymentoption.value != null)
  {
    // console.log(this.state.paymentoption.value,this.state.paymentoption);
    paymentop = this.state.paymentoption.value;
}
else
{
  
  this.state.paymentoption.map(po=>{
    paymentop = po.value
  })
}
var riderinfo = "";
  
  if(this.state.rider_id == null  )
  {
    if(this.state.rider_id != null)
    {
    riderinfo = this.state.rider_id.value;
    }
    else
    {
      riderinfo = "";
    }
  }else
  {
    // return;
   if(this.state.rider_id != null)
   {
    // this.state.rider_id.map(ri=>{
      
      if(this.state.rider_id.value != null)
      {
        riderinfo = this.state.rider_id.value
      }
      else
      {
        riderinfo = ""
      }
    // })
  }
  }
  var status = ""

    status = this.state.status

    
    this.setState({ processing:false }, () => {
      EditSubscriptionOrder(this.state.subscriber,today,this.state.deliverytype,this.state.deliverycharge,this.state.address_id,this.state.addressline1,this.state.addressline2,this.state.city,this.state.postalcode,this.state.country,channel,orderItemsform,obj,this.props.match.params.id,status,paymentop,dtoday,this.state.ordernote,riderinfo)
    .then((res)=>{
      if(res.data.success === false)
      {
        this.setState({processing:true})
        if(res.data.data.length != 0)
        {
          var ermessage = [];
          for (var key of Object.keys(res.data.data)) {
              var data = res.data.data[key]
              ermessage.push(data)
          }
          this.setState({ errormessages:  ermessage });
          
        }
        else
        {
          this.handleClick('bl')
        }
      }
      else if(res.data.success === true)
      {
        // this.pdfGenerateCall()
        // .then(val => {
          // if(val){
          //   this.odocFunction()
          //   this.setState({processing:true})
            this.handleSuccess('bl')
            setTimeout(() => {
              this.props.history.push('/admin/subscription_order_list');
            }, 3000);
          // }else{
          //   this.setState({processing:true})
          //   alert("please try again")
          // }
        // })
      }
      // this.props.history.push('/admin/order_list');
    })
    .catch((error) => {
      
      this.handleNetworkError('bl')
   });
  })
  }
      
    
  }
  
handleNetworkError(position)
{
  var color = Math.floor((Math.random() * 4) + 1);
  var level;
  switch (color) {
      case 1:
      level = 'success';
      break;
      case 2:
      level = 'warning';
      break;
      case 3:
      level = 'error';
      break;
      case 4:
      level = 'info';
      break;
      default:
      break;
  }
  level = 'error';
  this.state._notificationSystem.addNotification({
      title: (<span data-notify="icon" className="pe-7s-gift"></span>),
      message: (
          <div>
               <b>Network Error</b>.
          </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
  });
}

  serial = 1;
  getSerial() { 
    return this.serial++;
  }
  Add_New_Medication()
  {
    this.setState({
      showmediactonModal : true,
      medicationerrormessage : [],
      medicationitemcodeError : null,
      medicationitemnameError : null,
      medicationunitpriceError : null,
      medicationcategoryError : null,
      medicationcityError : null,
      medicationaddcommision : "1",
      medicationdescription : '',
      medicationunitprice : 0,
      medicationitemcode : '',
      medicationitemname : '',
      medicationcategory : '',
      medicationcity : '0',
    })

  }
  add_new_medication_category()
  {
    let error = false;
    if(this.state.medicationitemname.length == 0)
    {error = true
       this.setState({
        medicationitemnameError: (
            <small className="text-danger">
              Item Name is required.
            </small>
          )
        })
      }else{ this.setState({ medicationitemnameError: null });}
    if(this.state.medicationcategory == "0")
    {error = true
       this.setState({
        medicationcategoryError: (
            <small className="text-danger">
              Medication Category is required.
            </small>
          )
        })
      }else{ this.setState({ medicationcategoryError: null });}
    if(this.state.medicationunitprice.length == 0)
    {error = true
       this.setState({
        medicationunitpriceError: (
            <small className="text-danger">
              Unit Price is required.
            </small>
          )
        })
      }else{ this.setState({ medicationunitpriceError: null });}
      if(this.state.medicationitemcode.length == 0)
    {error = true
       this.setState({
        medicationitemcodeError: (
            <small className="text-danger">
              Item Code is required.
            </small>
          )
        })
      }else{ this.setState({ medicationitemcodeError: null });}
      if(this.state.medicationcity == "0")
      {error = true
         this.setState({
          medicationcityError: (
              <small className="text-danger">
                City is required.
              </small>
            )
          })
        }else{ this.setState({ medicationcityError: null });}
      if(!error)
      {
    var token = JSON.parse(localStorage.getItem('user'));  
    const  obj = token.token;
    var medicationaddcommision= "";
    if(this.state.medicationaddcommision == '1')
    {
      medicationaddcommision = "1"
    }
    else if(this.state.medicationaddcommision == '2')
    {
      medicationaddcommision = "0"
    }
    var medicationis_featured = ""
  if(this.state.medicationis_featured == '1')
  {
    medicationis_featured = "1"
  }
  else if(this.state.medicationis_featured == '2')
  {
    medicationis_featured = "0"
  }
    AddMedication(this.state.medicationitemname,this.state.medicationcategory,this.state.medicationitemcode,medicationaddcommision,this.state.medicationunitprice,this.state.medicationcity,this.state.medicationdescription,medicationis_featured,obj)
    .then(res => {
      if(res.data.success == false)
      {
        let message = res.data.data
        if(res.data.data.length != 0)
          {
        var ermessage = [];
        for (var key of Object.keys(res.data.data)) {
          var data = res.data.data[key]
          ermessage.push(data)
        }
        this.setState({ medicationerrormessage:  ermessage });
        this.medication_item_code_error.current.focus();
          this.setState({
            medicationitemcodeError : <small className="text-danger">
            {message.item_code }
        </small> });
      }
      else
      {
        this.handleClick('bl')
      }
      }else if(res.data.success == true)
      {


        var nmdata = ""; 
        nmdata= res.data.data;
        if(this.state.city_id == nmdata.city)
        {
        var medicationItems = [];
        if(nmdata != undefined)
        {
          var data = {value: nmdata.id, label : nmdata.title + '(' +nmdata.item_code+ ')'}

          var array1 = this.state.medicationItems;
          var array2 = array1.concat( data)

          var array1md = this.state.medication_detail;
          var array2md = array1md.concat( res.data.data)
          this.setState({  medication_detail : array2md,
            medicationItems : array2,  });
        }
      }
      else
      {
       // this.setState({medication_detail :  this.state.medication_detail ,
      //  medicationItems : this.state.medicationItems});
      }
        
      this.setState({
        showmediactonModal: false,
        medicationaddcommision : "1",
        medicationdescription : '',
        medicationunitprice : 0,
        medicationitemcode : '',
        // medicationprice : 0,
      
        medicationcategory : '',
        medicationcity : 0,

      })
    }
    })
    .catch((error) => {
      this.handleNetworkError('bl')
   });
  }
  }
  handleSelectChange = (index , value) => {

    let name ="description"
    const list = [...this.state.inputList];
    list[index][name] = value.value;
    var temp_arr = []
    //  temp_arr.push(value)
      list[index]["medicationItems"] = temp_arr
      list[index]["selectmedication"] =value
      const data = this.state.medication_detail[index].map( (medi) => {      
      if(list[index]['description'] == medi.id)
      {
        list[index]['unitprice'] = medi.price
        list[index]['discount'] = medi.discount
        list[index]['deliverycharges'] = medi.charge_value
      } 
    })
    
    list[index]['subtotal'] = list[index]['unitprice'] * list[index]['quantity']
    this.setState({inputList:list,
      // totalcost : '',
      // discountamount : 0 ,
        })
  this.handlebasketandsubtotal();
  // this.handletotalcost(this.state.deliverycharge);
  
  };
  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.inputList];
    list[index][name] = value;
    const data = this.state.medication_detail.map( (medi) => {      
      if(list[index]['description'] == medi.id)
      {
        list[index]['unitprice'] = medi.price
        list[index]['discount'] = medi.discount
        list[index]['deliverycharges'] = medi.charge_value
      } 
    })   


    //apply discount
    var discount = 0
  // console.log(this.state.b2borganizationdiscount)
  // if(this.state.b2borganizationdiscount != 0)
  // {
   /* if(this.state.dynamicfinalpercentage != 0)
    {
    discount =  parseFloat(this.state.dynamicfinalpercentage);
    }
    else
    {
    discount =  parseFloat(this.state.discount);
    }*/
    if(list[index]['discount'] != "")
    {
      discount = list[index]['discount']
    }
    
    var qty_wise_total = (list[index]['quantity']-1) * list[index]['unitprice'];
    var discounted_price = list[index]['unitprice'] - discount;
    //var delivery_charges_value = list[index]['unitprice']
    var subtotal = qty_wise_total + discounted_price




    //var addmargin =  subtotal * list[index]['newmargin'] / 100;
    
    list[index]['subtotal'] = subtotal;// + addmargin;
    list[index]['subtotal'] = list[index]['subtotal'].toFixed(2)

    
  this.handlebasketandsubtotal();
  this.setState({inputList:list,
    // totalcost : 0,
    // discountamount : 0 ,
    //   deliverycharge : 0
  })
  };
 
  // handle click event of the Remove button
  handleRemoveClick = index => {
    const list = [...this.state.inputList];
    list.splice(index, 1);
    this.setState({inputList:list})
  
      const list1 = list;
   
      let count_x =1;
       list1.map( (medi,ind) => {      
      list1[ind]['srno'] =count_x
      count_x++;
    })
    this.serial =  count_x
   
  this.setState({inputList:list1
  }) 
  this.handlebasketandsubtotal();
  };
  warningAddAddress(id,city_id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.addanother()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
        >
         If you change address it will reset all medication. Are you sure want to reset?
        </SweetAlert>
      )
    });
  }
  warningChangeAddress(id,city_id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.addrssselect(id,city_id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
        >
          If you change address it will reset all medication. Are you sure want to reset?
        </SweetAlert>
      )
    });
  }
  async addrssselect(id,city_id)
  {
    this.setState({inputList :  []}) //empty exitsing medictaion list
   
    this.setState({
      address_id : id,
      city_id : city_id,
      alert: null,
      medicationItems : [],
      medication_detail : [],
    //  addressaccess : '0',
      cityError : null,
      countryError : null,
     
      
    })
   
    if(id != "" && id != 0)
    {
      this.setState({addnewaddress :false, addressaccess : '0'})
    }
    else{
      this.setState({addnewaddress :true, addressaccess : '1',})
    }
    this.setState({medicationloading : false})
  
    this.serial = this.state.inputList.length + 1
  
    if(this.state.inputList.length == 0)
    {
     // this.handlebasketandsubtotal()
    }
  }

  handleFileChange(event) {
    let data = []
    data.push(event.target.files)
    this.setState({ selectedFile :data  });
 }
 hideAlertquote() {
  this.setState({
    alertquote: null
  });
}
sendToParent = async(name,i) => {
  //this.props.searching(this.state.name);c
  // console.log(this.state.name)
 // alert("==="+this.state.name.trim()+"===")
//  console.log(this.state.name,"state name")
 if(this.state.name.length !== 0){
  // console.log("in if",this.state.name)
      let compelte =1   
        let pg_no = 1
        var token = JSON.parse(localStorage.getItem('user'));
        // console.log(token.token);  
        const  obj = token.token;
        var city_id = this.state.city_id
  await  searchPackageForOrder(this.state.name,pg_no,obj)
        .then(res=> {
          const list = [...this.state.inputList];
          
          var mdata = res.data.data
          
          var medicationItems = []
         
            //alert("in else")
            this.setState({ medication_detail : []  }); 
            
            res.data.data.map((x, i) => {
              medicationItems.push({ value:x.id , label: x.title })
            })
            list[i]["medicationItems"] = medicationItems
            this.setState({inputList:list});

            var mew_arr = this.state.medicationItems;
            mew_arr[i] = medicationItems
            var array1md = this.state.medication_detail;
            var array2md = array1md.concat( res.data.data)
            var medi_array = [];
            medi_array[i] =array2md

            this.setState({  medication_detail : medi_array,
              medicationItems : mew_arr,  });
     
        
        
      })
    }
    else{
      const list = [...this.state.inputList];
        list[i]["medicationItems"] = []
              this.setState({inputList:list});
      this.setState({  medication_detail : [],
        medicationItems : [],  });
    }
}
displayNoteb()
{
  var note = !this.state.notedisplay
  this.setState({ notedisplay: note  });  
}
displayorderNote()
{
  var ordernote = !this.state.ordernotedisplay
  this.setState({ordernotedisplay : ordernote  });
}
inputOnChange = (event,i) => {
  const self = this;

  if (self.state.typingTimeout) {
     clearTimeout(self.state.typingTimeout);
  }

  self.setState({
     name: event.target.value.trim(),
     typing: false,
     typingTimeout: setTimeout(function () {
         self.sendToParent(self.state.name,i);
       }, 500)
  });
}
downshiftOnChange = (selectedItem ,i) => {
  

    var index = i;
  
  var d = selectedItem.id
  
  this.setState({ selectedmedication :  d });
  
  let name ="description"
    const list = [...this.state.inputList];
    list[index][name] = selectedItem.id;
    list[index]['medi_title'] = selectedItem.title
    list[index]['medi_itemcode'] = selectedItem.item_code
    list[index]['unitprice'] = selectedItem.price
     
  
    list[index]['subtotal'] = list[index]['unitprice'] * list[index]['quantity'] 
    list[index]['subtotal'] = list[index]['subtotal'].toFixed(2)


    this.setState({inputList:list,
      totalcost : '',
      discountamount : 0 ,
        })
  this.handlebasketandsubtotal(); 
  //alert(`your  Selected Medication  ${selectedItem.id}`)
  
}
prescriptionDisplay(opt){
  document.getElementById(opt).click()
}
hideAlert() {
  this.setState({
    alert: null
  });
}
  render() {
    const subscriber_detail = this.state.subscriber_detail;
    const country_detail = this.state.country_detail;
    const order = this.state.orderdetail;
    const view = <Tooltip id="view">View</Tooltip>;
    const subscriptiondetail = this.state.subscriptiondetail;
    const medicationdata = this.state.medicationdata;
    const quanitydata = this.state.quanitydata;
    var c = 1;
    var p = 1;
    var b= 1;
    const errormessages = this.state.errormessages;
    const medicationerrormessage = this.state.medicationerrormessage;
    
    return (
      <div className="main-content">
         {this.state.contentLoading ? <LoadingOrder /> : "" }
        <Grid fluid>
        <NotificationSystem ref="notificationSystem" style={style}/>
        {this.state.alert}
        {this.state.alertquote}

      <Card
                 content={
                  <Row>
                    
               <Col sm={8}>
                 <input  style={{width:'0px',height:'0px',border:'none'}} type="text" ref={this.message_error} />
                    {errormessages.length != 0 && 
                    <div className=' alert alert-danger'> 

                    {errormessages.map((data) => (
                            <React.Fragment>
                            <li>{data}</li>
                            </React.Fragment>
                          ))}
                          </div> }
                          <br/>
                      
                    <div>
                    {/* <Col md="6"> */}
                    <Col md="12" style={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        marginBottom: "10px",
                        borderColor: "#A9A9A9",
                        borderStyle:"dashed",
                        borderWidth:"2px",
                        borderRadius:"12px",
                        // marginTop: "8px",
                        // paddingTop:"18px",
                        // marginBottom: "10px",
                        
                       
                        // borderWidth:"2px",
                        // //backgroundColor:"#D3D3D3",
                        // borderRadius: "12px",
                      }}>
                    <Col md="6">
                    <FormGroup>
                    <br></br>
                    <ControlLabel>Subscriber</ControlLabel>
                    <select name="subscriber"   disabled="disabled" onChange={this.onChange} value={this.state.subscriber} className="form-control">
                        <option value="0">Select Subscriber</option>
                        {subscriber_detail.map((cus_detail)=> (
                          <option value={cus_detail.id} >{cus_detail.lead_name}</option>
                        ))}
                      </select>
                      {this.state.subscriberError}
                    </FormGroup>
                    </Col>
                    <Col md="6" style={{width:"45%"}}>
                    <FormGroup className="fl_datepicker">
                      <br></br>
                      <div style={{ position: "relative", bottom: "5px" }}>
                      <ControlLabel style={{
                                marginTop: "1px",
                                borderTop: "5px",
                              }}> Subscription Date</ControlLabel>
                      <Datetime
                        timeFormat={false}
                        dateFormat="YYYY-MM-DD"
                        inputProps={{ placeholder: "Order Date" }}
                        defaultValue={new Date()}
                        closeOnSelect={true}
                        value={this.state.subscription_date}
                        onChange={this.handlesubscriptionDateChange}/>
                        </div>
                      
                    </FormGroup>
                    </Col>
                
                    </Col>
                    </div>

                     <br/>
                    <hr></hr>


                    
                   <Col md={12} xs={12} lg={12} sm={12}>
                       <h3>Address</h3>
                       <Button style={{position: "absolute",marginLeft: "65%", marginTop: "-46px"}}
                     fill onClick={this.warningAddAddress.bind(this)}>Add Another Address<i className="fa fa-plus"></i></Button>
                       
                       {this.state.addressaccess == '1'?
                                           
                   <FormGroup>
                   <ControlLabel>Address Line 1</ControlLabel>
                     
                     <FormControl name="addressline1" value={this.state.addressline1} onChange={event => {
                       this.setState({ addressline1: event.target.value });
                       
                     }} placeholder="Enter Address Line1" type="text" />
                     {this.state.addressline1Error}
                     
                     <ControlLabel>Address Line 2</ControlLabel>

                     <FormControl name="addressline2" value={this.state.addressline2} onChange={this.onChange} placeholder="Enter Address Line2" type="text" />
                     
                     <ControlLabel>Postal code</ControlLabel>
                       
                       <FormControl name="postalcode" value={this.state.postalcode} onChange={event => {
                           this.setState({ postalcode: event.target.value });
                           // event.target.value === ""
                           //   ? this.setState({
                           //       postalcodeError: (
                           //         <small className="text-danger">
                           //           Postalcode is required.
                           //         </small>
                           //       )
                           //     })
                           //   : this.setState({ postalcodeError: null });
                         }}  placeholder="Enter Postal Code" type="number" />
                         {this.state.postalcodeError}
                         <ControlLabel>Country</ControlLabel>
                     
                     <select name="country" value={this.state.country} onChange={event => {
                     this.setState({ country: event.target.value });
                     
                   }} className="form-control">
                       <option value="0">Select Country</option>
                       {country_detail.map((country_data) => (
                         <option value={country_data.id}>{country_data.country_name}</option>
                       ))}
                     </select>
                     {this.state.countryError}
                     <br></br>
                     <ControlLabel>City</ControlLabel>
                     
                       <select className="form-control" name="city" value={this.state.city} onChange={this.onChange} >
                         <option value="0"> Select City</option>
                         {this.state.city_info.map(city => (
                           <option value={city.id}>{city.city_name}</option>
                         ))}
                         </select>
                     {this.state.cityError}
                     
                        </FormGroup>
                     :''}
                         <hr></hr>              
                       
                       
                       
                       <div style={{ 
                        paddingLeft: "30px",
                        paddingRight: "5px",
                        marginLeft: "-1%",
                        marginRight:"-3%",
                        paddingTop: "2%",
                        paddingBottom: "2%",
                        borderColor: "#A9A9A9",
                        borderStyle: "dashed",
                        borderWidth: "2px",
                        borderRadius: "12px",
                        }} > 
                       {this.state.addressdata.map((add)=>(
                       <p> <div style={{  
                        borderColor: "#D3D3D3"}}>
                          <input name="addressradio" 
                            checked={this.state.address_id == add.id ? 'true' : ''}  
                            onChange={this.warningChangeAddress.bind(this,add.id,add.city)} type="radio">
                          </input>  {add.address_line1},{add.address_line2} ,
                        {this.state.city_info.map(city => (
                         <React.Fragment>
                           {city.id == add.city ? city.city_name : ''}

                         </React.Fragment>
                       ))} ,
                        {country_detail.map((country_data) => (
                          <React.Fragment>
                           {country_data.id == add.country_id ? country_data.country_name +',' : ''} </React.Fragment>
                         ))}
                         {add.postal_code}
                         {this.state.address_id == add.id ? <i style={{'color':'green','font-size':'20px'}} className="fa fa-check"></i> : ''}                           
                        </div> </p> 
                       ))}
                        </div>
                  
                     </Col>
                     <hr></hr>
                    
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     {this.state.subscriber != 0 ? 
                     this.state.address_id != 0 || this.state.city_id != 0  ?
                       <React.Fragment>
                          <div
                             className="testhere"
                            style={{
                              // backgroundColor: "#D3D3D3",
                              // position: "relative",
                              //  top: "219px",
                             }}
                          > <hr></hr></ div>
                           <div>
                    <h3>&nbsp;Order Detail</h3>
                    </div>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <div style={{
                                position: "absolute",
                                marginLeft: "75%",
                                marginTop: "-41px",
                              }}>
                        <Button style={{ color: "#2B3A41" }}  
                        onClick={this.handleAddClick}> <i  className="fa fa-plus"></i> Add Package</Button>
                      {/* &nbsp;
                        <Button style={{ color: "#2B3A41" }}  
                         onClick={this.Add_New_Medication.bind(this)} > <i  className="fa fa-plus"></i> Add New Medicine</Button> */}
                      </div>
                      </Col>  
                    

                    <div >
    
        <div className="table-responsive">
          <Table className="fl_order_details">
            <thead>
              <tr>
                <th><ControlLabel>&nbsp;Sr.No </ControlLabel></th>
                <th><ControlLabel>Package Name </ControlLabel></th>
                <th><ControlLabel>Unit Price </ControlLabel></th>
                <th><ControlLabel>Quantity </ControlLabel></th>
                <th><ControlLabel>Discount </ControlLabel></th>
                <th><ControlLabel>Charges </ControlLabel></th>
                <th><ControlLabel>SubTotal </ControlLabel></th>
                <th></th>
              </tr>
            </thead>

            <tbody>
            { this.state.inputList.map((x, i) => {
                return (
                  <tr>
                    <td style={{ 'width': 'min-content' }}>
                      <FormControl name="srno" disabled="disabled" value={x.srno} onChange={e => this.handleInputChange(e, i)} placeholder="1" type="text" />
                    </td>
                    <td style={{ 'width': '40%' }}>

                      <div onKeyUp={e =>this.inputOnChange(e,i)} className="Appy">
                          <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="description"
                                value={x.description==="" ? "" : x.selectmedication}
                                onChange={value => this.handleSelectChange( i,value)} 
                                options={x.medicationItems}
                                placeholder="Package"
                                noOptionsMessage={() => "Type Package Name "}
                              />  
                        </div>
                   
                    </td>
                    <td>
                      <FormControl className="no-padding" name="unitprice" disabled="disabled" value={x.unitprice} onChange={e => this.handleInputChange(e, i)} placeholder="0.00" type="number" />
                    </td>
                    <td>
                      <FormControl className="no-padding" name="quantity"  min={1} value={x.quantity} onChange={e => this.handleInputChange(e, i)} placeholder="1" type="number" />
                    </td>
                    <td>
                        <FormControl className="no-padding" name="discount"  min={1} value={x.discount} onChange={e => this.handleInputChange(e, i)} placeholder="1" type="number" readOnly="readonly" />
                    </td>
                    <td>
                      <FormControl className="no-padding" name="charges"  min={1} value={x.deliverycharges} onChange={e => this.handleInputChange(e, i)} placeholder="1" type="number" readOnly="readonly" />
                    </td>
                    <td>
                      <FormControl className="no-padding" name="subtotal" disabled="disabled" value={x.subtotal} onChange={e => this.handleInputChange(e, i)}placeholder="1" type="number" />
                    </td>
                    <td>
                        <a href="javascript:void(0)" onClick={ e=>this.handleRemoveClick(i)} >X</a>
                    </td>
                  
                  </tr>              
                )
              }
        
            )}
            </tbody>
          </Table>
          {this.state.medicationaddError}
        </div>
               
      </div>
         
          </React.Fragment>
           : ''
          : ''}
           <React.Fragment>
          {this.state.subscriber != 0 ?
          this.state.address_id != 0 || this.state.city_id != 0  ?
      <Row>
                     
                      <Modal
                      show={this.state.showmediactonModal}
                      onHide={() => this.setState({ showmediactonModal: false })}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Medication Details</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                      <input
                    style={{width:'0px',height:'0px',border:'none'}}
          type="text"
          ref={this.medication_item_code_error} />
                      {medicationerrormessage.length != 0 && 
                        <div className=' alert alert-danger'> 

                        {medicationerrormessage.map((data) => (
                          <React.Fragment>
                          <li>{data}</li>
                          </React.Fragment>
                        ))}
                        </div> }
                          <FormGroup>
                            <ControlLabel>Item Code</ControlLabel>
                            <FormControl name="medicationitemcode" value={this.state.medicationitemcode} type="number" placeholder="Enter Itemcode" onChange={this.medicationChange}></FormControl>
                            {this.state.medicationitemcodeError }
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Item Name</ControlLabel>
                            <FormControl name="medicationitemname" value={this.state.medicationitemname} type="text" placeholder="Enter Item Name" onChange={this.medicationChange}></FormControl>
                            {this.state.medicationitemnameError}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Medication Category</ControlLabel>
                            <select name="medicationcategory" onChange={this.medicationChange} value={this.state.medicationcategory} className="form-control" >
                              <option value="0">Select Medication Category</option>
                              {this.state.category_detail.map(mcatdata=> (
                                <option value={mcatdata.id}>{mcatdata.category_name}</option>
                              ))}
                            </select>
                            {this.state.medicationcategoryError}

                          </FormGroup>
          
                          
                          <FormGroup>
                            <ControlLabel>Unit Price</ControlLabel>
                            <FormControl name="medicationunitprice" value={this.state.medicationunitprice} type="number" placeholder="Enter UnitPrice" onChange={this.medicationChange}></FormControl>
                            {this.state.medicationunitpriceError}
                          </FormGroup>
                          <FormGroup>
                        <ControlLabel>City</ControlLabel> 
                        <select className=" primary form-control" name="medicationcity" value={this.state.medicationcity} onChange={this.medicationChange}  >
                        <option value="0">Select City</option>
                         {this.state.city_info.map((cus)=> (   
                        <option value={cus.id}>{cus.city_name}</option>
                        ))} 
                        </select>      
                        {this.state.medicationcityError}       
                        </FormGroup>       
                          <FormGroup>
                            <ControlLabel>Add Commision 10%</ControlLabel>
                            <Radio
                            // style={{'display':'inline-block'}}
                            number="10"
                            option="1"
                            name="medicationaddcommision"
                            onChange={this.medicationChange}
                            checked={this.state.medicationaddcommision === "1"}
                            label="Yes"
                          />
                          <Radio
                            // style={{'display':'inline-block'}}
                            number="11"
                            option="2"
                            name="medicationaddcommision"
                            onChange={this.medicationChange}
                            checked={this.state.medicationaddcommision === "2"}
                            label="No"
                          />
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Description</ControlLabel>
                            <textarea className="form-control" name="medicationdescription" value={this.state.medicationdescription} cols={3} rows={2} placeholder="Enter Description" onChange={this.medicationChange}></textarea>
                            {this.state.medicationdescriptionError}
                          </FormGroup>
                          <FormGroup>
                                           <ControlLabel>Is Featured ? &nbsp;</ControlLabel>
                                           <Radio
                                           // style={{'display':'inline-block'}}
                                           number="12"
                                           option="1"
                                           name="medicationis_featured"
                                           onChange={this.medicationChange}
                                           checked={this.state.medicationis_featured === "1"}
                                           label="Yes"
                                         />
                                         <Radio
                                           // style={{'display':'inline-block'}}
                                           number="13"
                                           option="2"
                                           name="medicationis_featured"
                                           onChange={this.medicationChange}
                                           checked={this.state.medicationis_featured === "2"}
                                           label="No"
                                         />
                                         </FormGroup>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button bsStyle="info" fill onClick={this.add_new_medication_category.bind(this)}>Submit</Button>
                        </Modal.Footer>
                        </Modal>
                    </Row>
                           : ""
                           : ''}
                           </React.Fragment>
                           <hr></hr>

                           <Row> 
                        <br/>
     
      <Col xs={12} sm={12} md={12} lg={12}  style={{
                          position: "relative",
                          minHeight: "1px",
                          paddingRight: "26px",
                          paddingLeft: "25px",
                        }} >
      <Row style={{
                            paddingBottom: "2%",
                            paddingLeft: "-1%",
                            paddingRight: "2%",
                            paddingTop: "3%",
                            borderStyle: "dashed",
                            borderColor: "#A9A9A9",
                            borderWidth:"2px",
                            borderRadius: "12px",
                            marginRight:"-3%",
                            marginLeft:"-1px"
                            //marginLeft:"-1%"
                          }}>
      {/* style={{
                            paddingBottom: "2%",
                            paddingLeft: "1%",
                            paddingRight: "8%",
                            marginTop:"2%",
                            borderStyle: "dashed",
                            borderColor: "#A9A9A9",
                            borderWidth:"2px",
                            borderRadius: "12px",
                            marginRight:"10px",
                            marginLeft:"26px"
                            //marginLeft:"-1%"
                          }} */}
                       
                        <Col md={3} sm={3} lg={4} xs={12} >
                          
                          <ControlLabel className="no-padding">Delivery Date</ControlLabel>
                          <FormGroup className="fl_datepicker">
                      <div style={{ position: "relative", bottom: "5px" }}>
                      <Datetime
                        timeFormat={false}
                        dateFormat="YYYY-MM-DD"
                        inputProps={{ placeholder: "Delivery Date" }}
                        defaultValue={new Date()}
                        closeOnSelect={true}
                        value={this.state.delivery_date}
                        onChange={this.handledeliveryDateChange}/>
                        </div>
                        </FormGroup>
                        </Col>
                        
                        <Col md={3} sm={3} lg={4} xs={12} >   
                        <FormGroup className="order_source_data ">
                         <ControlLabel className="fl-w-100">Delivery Type</ControlLabel>
                      
                      <Radio
                            number="3"
                            option="1"
                            name="deliverytype"
                            onChange={this.onChange}
                            checked={this.state.deliverytype === "1"}
                            label="Normal"
                          />
                          <Radio
                            number="4"
                            option="2"
                            name="deliverytype"
                            onChange={this.onChange}
                            checked={this.state.deliverytype === "2"}
                            label="Express"
                          />
                    </FormGroup>
                    </Col>
                    {/*}
                    <Col md={4} sm={4} lg={4} xs={12} >   
                    <FormGroup>
                        <Button style={{ color: "#2B3A41" }} onClick={this.opendiscountmodal.bind(this)} > Add Dynamic Discount</Button>
                    </FormGroup>
                    <FormGroup>
                    {this.state.dynamicfinalpercentage != 0 ?
                      <p> Added Discount : {this.state.dynamicfinalpercentage} LKR</p>
                      : ''}
                    </FormGroup>
                    </Col> */}
                    <Col md={3} sm={3} lg={4} xs={12} >
                          {/** check box goes here */}
                        </Col>
                    
                    <Col md={12} xs={12} sm={12} lg={12}   >
                      <Col md={4} xs={4} sm={4} lg={4} className="no-padding" style={{width:"30%"}}>
                      <ControlLabel>Payment Option</ControlLabel>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Payment Option"
                          name="paymentoption"
                          
                          value={this.state.paymentoption}
                          onChange={value => this.setState({
                            paymentoption : value
                          })
                          }
                          options={[
                            // {value: 'Cash',label : 'Cash'},
                            {value: 'Card',label : 'Card'},
                            // {value: 'Cheque',label : 'Cheque'},
                            // {value: 'Bank Transfer',label : 'Bank Transfer'},
                            // {value: 'Hybrid',label : 'Hybrid'},
                          ]}
                        />
                        {this.state.paymentoptionError}
                      </Col>
                     
                        <Col md={4} xs={4} sm={4} lg={4} className="" >
                      <FormGroup className="fl_datepicker">
                      
                      <div style={{ bottom: "5px" }}>
                      <ControlLabel >Rider : </ControlLabel>
                      <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Rider"
                          //style={{ width:"10%" }}
                          name="rider_id"
                          
                          value={this.state.rider_id}
                          onChange={value => this.setState({
                            rider_id : value
                          })
                          }
                          options={this.state.rider_data}
                          
                        />
                       
                        </div>
                        </FormGroup>
                        </Col>
                      </Col>
                      
                     
                      <Col md={12} xs={12} sm={12} lg={12} style={{   marginLeft:"1px", width:"91%"}} > 
                     
                     <FormGroup>
                       <ControlLabel>Note</ControlLabel>
                       <textarea className="form-control" rows="4" cols="5" placeholder="Enter Note"  onChange={(event) => {
                              this.setState({ ordernote: event.target.value });
                            }} value={this.state.ordernote || ""}></textarea>
                       </FormGroup>
                       
                     </Col>
                    
                    
                    
               
                      <Col md={12} xs={12} sm={12} lg={12} className="no-padding">
               <Modal
                      show={this.state.discountmodal}
                      onHide={() => this.setState({ discountmodal: false })}
                    >
                      <Modal.Header >
                        <Modal.Title>Dynamic Discount</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                      <FormGroup>
                          <ControlLabel>Discount Value</ControlLabel>
                          <FormControl type="number" value={this.state.discountpercentage} onChange={this.onChange} name="discountpercentage" placeholder="0%" ></FormControl>
                        </FormGroup>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button  onClick={this.submitdynamicdiscount.bind(this)}  fill>Submit</Button>&nbsp;
                          <Button  onClick={this.closedynamicdiscount.bind(this)}  fill>Close</Button>
                        </Modal.Footer>
                        </Modal>
                        <Modal
                      show={this.state.prescriptionmodal}
                      onHide={() => this.setState({ prescriptionmodal: true })}
                    >
                      <Modal.Header >
                        <Modal.Title>Prescription Details</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                      <FormGroup>
                        {/* <Row>
                        <Col md={8} className="mt-3">
                            <Col md={3}><img  style={{height:'30px',width:'30px'}}  src={this.state.priscriptionurl} /></Col>
                            <Col md={4}><ControlLabel>Prescription 1 </ControlLabel></Col>
                            <Col md={2}><a className="btn " href={this.state.priscriptionurl} target="_blank" >View</a></Col>
                        </Col>
                        </Row> */}
                        {/* {this.state.priscriptionurl} */}
                        <Row>
                        <Col md={8} className="mt-3">
                        {this.state.priscriptionurl.map((pre)=>(                        

                            <Col md={2}><a className="fa fa-file" style={{'font-size':'45px','color':'black'}} href={pre.prescription_url} target="_blank" ></a></Col>
                            
                            ))}
                        </Col>
                        </Row>
                        
                        </FormGroup>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button  onClick={this.closeprescriptionmodal.bind(this)}  fill>Close</Button>
                        </Modal.Footer>
                        </Modal>
                        <Modal
                      show={this.state.marginmodal}
                      onHide={() => this.setState({ marginmodal: false })}
                    >
                      <Modal.Header >
                        <Modal.Title>Dynamic Margin</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <FormGroup  className="order_source_data">
                          <ControlLabel>Select Margin Type</ControlLabel>
                          &nbsp;
                          <Radio
                            style={{'display':'inline-block'}}
                            number="8"
                            option="1"
                            name="margintype"
                            onChange={this.onChange}
                            checked={this.state.margintype === "1"}
                            label="Margin Percentage"
                          />&nbsp;
                          <Radio
                            style={{'display':'inline-block'}}
                            number="9"
                            option="2"
                            name="margintype"
                            onChange={this.onChange}
                            checked={this.state.margintype === "2"}
                            label="Margin in cash"
                          />
                        </FormGroup>
                        {this.state.margintype == 1 ? 
                        <FormGroup>
                          <ControlLabel>Margin Percentage</ControlLabel>
                          <FormControl type="number" onChange={this.onChange} value={this.state.marginpercentage} name="marginpercentage" placeholder="0%" ></FormControl>
                        </FormGroup>
                        :''}
                        {this.state.margintype == 2 ?
                         <FormGroup>
                        <ControlLabel>Margin Amount</ControlLabel>
                        <FormControl type="number" onChange={this.onChange} value={this.state.marginamount}  name="marginamount" placeholder="0.00" ></FormControl>
                      </FormGroup> : ''}
                        </Modal.Body>
                        <Modal.Footer>
                          <Button onClick={this.submitdynamicmargin.bind(this)} bsStyle="success" fill> Submit</Button> &nbsp;
                          <Button onClick={this.closedynamicmargin.bind(this)} bsStyle="info" fill> Close</Button>
                        </Modal.Footer>
                        </Modal>

                        
                    </Col>
                   </Row>
                   <br/>
                  
                    <Button disabled={!this.state.processing} onClick={this.onSubmit.bind(this)} class="btn-color" fill>
                      Update
                    </Button> 
                    </Col>

                   
                    
                    <Modal
                      show={this.state.showModal}
                      onHide={() => this.setState({ showModal: false })}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Medication Details</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        
                         
                      <p key={subscriptiondetail.id} > TotalCost :  {(subscriptiondetail.total_cost-0).toFixed(2)}</p>
                              
                              <p>Delivery Type : {subscriptiondetail.delivery_type == "1" ? "Flash" : 'oPharma'}</p>
                              {subscriptiondetail.delivery_charge != null   ? 
                              <p>Delivery Charge : {(subscriptiondetail.delivery_charge-0).toFixed(2)}</p> : ''}
                              {subscriptiondetail.organization_discount > 0 ?
                              <p>Discount : {(subscriptiondetail.organization_discount-0).toFixed(2)}</p>
                               : ''}
                    
                    
                  
                               <Table>
                                 <thead>
                                   <tr>
                                     <th>Medication</th>
                                     <th>Unit Price</th>
                                     <th>Quantity</th>
                                   </tr>
                                 </thead>
                               <tbody>
                               {this.state.medicationdataList.map(data=>( 
                                 <tr>
                                   <td key={data.medicine.id}>{data.medicine.title}</td>
                                   <td>{(data.medicine.price-0).toFixed(2)}</td>
                                   <td>{data.quantity}</td>
                                 </tr>
                                 ))}  
                                 </tbody>
                                 

                              </Table>

                        
                      </Modal.Body>
                    </Modal>

                   
             <Row>

             


          <Col md={12}>                        
                    {/* <h3>Shipping Details</h3> */}
                    
           <Row>
                      {/* <Col md={6}>
                      <FormGroup>
                      <ControlLabel>Name</ControlLabel>
                      <FormControl name="name" value={this.state.name} onChange={event => {
                        this.setState({ name: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                              nameError: (
                                <small className="text-danger">
                                  Name is required.
                                </small>
                              )
                            })
                          : this.setState({ nameError: null });
                      }} placeholder="Enter Name" type="text" />
                      {this.state.nameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Mobile No</ControlLabel>
                      <FormControl name="mobileno" value={this.state.mobileno} onChange={event => {
                        this.setState({ mobileno: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                              mobilenoError: (
                                <small className="text-danger">
                                  Mobile No is required.
                                </small>
                              )
                            })
                          : this.setState({ mobilenoError: null });
                      }} placeholder="Enter Mobile No" type="number" />
                      {this.state.mobilenoError}
                    </FormGroup>
                    
                    <FormGroup>
                      <ControlLabel>Phone No</ControlLabel>
                      <FormControl name="phoneno" value={this.state.phoneno} onChange={event => {
                        this.setState({ phoneno: event.target.value });
                        // event.target.value === ""
                        //   ? this.setState({
                        //       phonenoError: (
                        //         <small className="text-danger">
                        //           Phone No is required.
                        //         </small>
                        //       )
                        //     })
                        //   : this.setState({ phonenoError: null });
                      }} placeholder="Enter Phone No" type="number" />
                      {this.state.phonenoError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Status</ControlLabel>
                      <select name="status" onChange={event => {
                        this.setState({ status: event.target.value });
                        event.target.value === "0"
                          ? this.setState({
                              statusError: (
                                <small className="text-danger">
                                  Status is required.
                                </small>
                              )
                            })
                          : this.setState({ statusError: null });
                      }} value={this.state.status} className="form-control">
                        <option value="0">Select Status</option>                     
                          <option value="1">Submitted</option>
                          <option value="2">Processing</option>
                          <option value="3">Dispatched</option>
                          <option value="4">Delivered</option>
                          <option value="5">Cancelled</option>
                          <option value="6">Attempted</option>
                          <option value="7">Unreachable</option>
                        </select>
                        {this.state.statusError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Email</ControlLabel>
                      <FormControl name="email" value={this.state.email} onChange={event => {
                        this.setState({ email: event.target.value });
                        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                              emailRex.test(event.target.value) === false
                                ? this.setState({
                                    emailError: (
                                      <small className="text-danger">
                                        Email format should be{" "}
                                        <i>abc@doe.com</i>.
                                      </small>
                                    )
                                  })
                                : this.setState({ emailError: null });
                      }} placeholder="Enter Email" type="email" />
                      {this.state.emailError}
                    </FormGroup>
                      </Col> */}
                     
                      <Col md={12} sm={12} lg={12} xs={12} >
                     
                    </Col>
                    </Row>
                      </Col>
                    </Row>
                    
                    </Row>

                    <Row>
          <Col md={12}>                        
           <Row>
                      <Col md={12} sm={12} lg={12} xs={12} >
                      <Col md={12} sm={12} lg={8} xs={12} >

                        <hr></hr>
                         <h3>Delivery History</h3>
                         <Table responsive>
                         <thead>
                         <tr>
                           <th>#</th>
                        <th>Delivery Date</th>
                        <th>Card Number</th>
                        {/* <th>OPharma Referance</th> */}
                        <th>rider</th>
                        <th>status</th>
                        <th>action</th>
                        <th>Invoice</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.noRecordFound ? <tr><td colspan="10"><center>No record found</center></td></tr> :
                    <React.Fragment>
                    {this.state.delivery_data.map((lastd)=> (
                      <tr>
                        <td>{c++}</td>
                        <td>{lastd.delivery_date}</td>
                        <td>{lastd.card_no}</td>
                        <td>{lastd.rider_name}</td>
                        <td>{lastd.is_delivered}</td>
                        <td>{lastd.is_delivered === 0 && <Button onClick={this.updateStatus.bind(this,lastd.id)} >Update Status</Button>}</td>
                        <td> <Button  //bsStyle="danger"
                           onClick={this.downloadinvoice.bind(this,lastd.id)}  >View</Button></td>
                       
                       {/* <td className="text-right">
                                  <OverlayTrigger placement="top" overlay={view}>
                            <Button simple bsStyle="info"  onClick={this.lastorderdetail.bind(this,lastd.id)}  bsSize="xm">
                          <i className="fa fa-user" />
                        </Button>
                      </OverlayTrigger></td>*/} 
                      
                                    </tr>
                                    
                  ))}
                    </React.Fragment>
                                }
                    </tbody>
                    </Table>
                    </Col>
                    </Col>
                    </Row>
                      </Col>
                    </Row>

                    <hr></hr>
                    </Col>
                    
           

{/* <React.Fragment> */}
            {this.state.subscriber != 0 ? 
            <Col sm={4} className="fl_sticky_side ">
              
                <div className="dropdown-AddOrder" style={{marginTop:"6%"}} 
                 >

              <Card
               style={{borderColor:"none", 
               paddingLeft: "1%",
               paddingRight: "1%",
               paddingTop: "2%",
           
               paddingBottom:"2%"
               //marginRight:"-8%"
               
               
             }}
            
                title="Customer Detail"
                category=""
                content={
                  <Row>
                    <Col md={12}>
                      <div className="table-responsive ">
                        <table className="table">
                          <tbody>
                            {/* <React.Fragment> */}
                          <tr >
                            <td className="text-left">Name</td>
                            <td className="text-right">{this.state.username != null ? this.state.username : '-'}</td>
                          </tr>
                          <tr>
                            <td className="text-left">Phone Number</td>
                            <td className="text-right">{this.state.userphone != null ? this.state.userphone : '-'}</td>
                          </tr>
                          <tr>
                            <td className="text-left">Mobile Number</td>
                            <td className="text-right">{this.state.usermobile != null ? this.state.usermobile : '-'}</td>
                          </tr>
                          <tr>
                           <td className="text-left">Email Adress</td>
                            <td className="text-right">{this.state.useremail != null ? this.state.useremail : '-'}</td>
                          </tr>
                          
                          {this.state.b2baccess == 1 ?
                          <React.Fragment>

                          <tr>
                            <td colSpan="2" className="fl_b2bdetails" > <h4>B2B Detail</h4></td>

                          </tr>
                          <tr>
                            <td className="text-left">Company name</td>
                            <td className="text-right">{this.state.companyname  != null ? this.state.companyname : '-'}</td>
                          </tr>
                          <tr>
                            <td className="text-left"> Delivery Charge </td>
                            <td className="text-right"><b>{this.state.b2bdeliverycharge  != null? this.state.b2bdeliverycharge : '-'}</b></td>
                          </tr>
                          <tr>
                            <td className="text-left">Discount</td>
                            <td className="text-right"><b>{this.state.discount  != null ? this.state.discount + '%' : '-'} </b></td>
                          </tr>
                          <tr>
                            <td className="text-left">Company Note</td>
                            <td className="text-right">{ this.state.companynote != null ? this.state.companynote : '-'}</td>
                          </tr>
                          </React.Fragment>

                          : ''}


                          </tbody>
                        </table>
                      </div> 
                    </Col>
                  
                  
                  </Row>
                }
              />
              </div>
              <br></br>
               <div className="dropdown2-AddOrder">
              <Card
                title="Basket info"
                category=""
                content={
                  <Row>
                    <Col md={12}>
                      <div className="table-responsive ">
                        <table className="table">
                          <tbody>
                          <tr>
                            <td>Basket Value</td>
                            <td>
                      <FormControl name="basketvalue" className="fl_basket_inpt fl_basketinfoupdated" disabled="disabled" value={this.state.basketvalue} onChange={this.onChange} placeholder="0.00" type="number" />
                              
                              </td>  
                          </tr>
                          {/*
                          <tr>
                            <td>
                            Delivery Charge
                            </td>
                            <td>
                      <FormControl name="deliverycharge" className="fl_delivery_charge_inpt fl_deliverycharge" value={this.state.deliverycharge} onChange={this.onChange} placeholder="0.00" type="number" />

                            </td>
                            </tr> */}
                            <tr>
                              <td>Total Cost</td>
                              <td>
                              <FormControl name="totalcost" className="fl_total_cost_inpt fl_basketinfoupdated" disabled="disabled" value={this.state.loading ? <LoadingSpinner /> :this.state.totalcost} onChange={event => {
                        this.setState({ totalcost: event.target.value });
                        event.target.value === ""
                          ? this.setState({
                              totalcostError: (
                                <small className="text-danger">
                                  Total Cost is required.
                                </small>
                              )
                            })
                          : this.setState({ totalcostError: null });
                      }} placeholder="0.00" type="number" />
                        {this.state.totalcostError}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div> 
                    </Col>            
                  </Row>
                }
              />
</div>
            </Col>
            : ''}                 
              </Row>
                }
              />
        </Grid>
      </div>
    );
  }
}

export default editsubscriptionOrder;
